module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTI0IDIwLjE4OEwxNS42ODUgMTEuOTc5TDIzLjg4NSAzLjY5N0wyMC4xODggMEwxMS45NzYgOC4zMThMMy42NjYgMC4xMTVMMCAzLjc4MUw4LjMyMSAxMi4wMjFMMC4xMTUgMjAuMzM0TDMuNzgxIDI0TDEyLjAxOCAxNS42ODJMMjAuMzAzIDIzLjg4NUwyNCAyMC4xODhaIiBmaWxsPSJ3aGl0ZSIvPgo8L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./src/components/Galerija/FullScreen/cross-icon.svg
// module id = 1005
// module chunks = 132729432747416